import { Row, Col } from 'src/componentes/grid';

import Input from 'src/componentes/input';
import DatePicker from 'src/componentes/date-picker';
import NivelEducacionalLookup from 'src/lookups/NivelEducacionalLookup';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { COLABORADOR_CAMPOS } from 'src/utils/constants';

import { hasSearchMatch } from './searchUtils';

const FormacaoSection = ({ model, intl, campos, searchQuery }) => {
  if (!campos[COLABORADOR_CAMPOS.FORMACAO_ACADEMICA]) return null;

  const fieldMatches = (terms) => hasSearchMatch(searchQuery, terms);
  const sectionTerms = [
    intl.formatMessage({ id: 'formacoesAcademicas' }),
    intl.formatMessage({ id: 'nivelEducacional' }),
    intl.formatMessage({ id: 'curso' }),
    intl.formatMessage({ id: 'instituicaoEnsino' }),
    intl.formatMessage({ id: 'dataConclusao' }),
  ];

  if (!hasSearchMatch(searchQuery, sectionTerms)) return null;

  return (
    <CollapsibleSection title={intl.formatMessage({ id: 'formacoesAcademicas' })}>
      <Row>
        {fieldMatches([intl.formatMessage({ id: 'nivelEducacional' })]) && (
          <Col md={12}>
            <NivelEducacionalLookup clearable model={model.getModel('nivelEducacional')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'curso' })]) && (
          <Col md={12}>
            <Input model={model.getModel('cursoFormacao')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'instituicaoEnsino' })]) && (
          <Col md={12}>
            <Input model={model.getModel('instituicaoEnsino')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'dataConclusao' })]) && (
          <Col md={12}>
            <DatePicker
              timeFormat={false}
              model={{
                label: intl.formatMessage({ id: 'dataConclusao' }),
                value: model.getModel('dataConclusaoFormacao').value,
                requestChange: model.getModel('dataConclusaoFormacao').requestChange,
                errors: model.getModel('dataConclusaoFormacao').errors,
              }}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default FormacaoSection;
